import { gql } from '@apollo/client';

export const fetchCloudSitesForWidgetPPC = gql`
  query fetchCloudSitesForWidgetPPC($params: SearchCloudLicensesParams!) {
    cloudLicenses(params: $params) {
      nodes {
        cloudSiteUrl
        billingGroupId
        cloudSiteId
        shipToParty {
          name
        }
      }
    }
  }
`;
